import { Box } from 'grommet';
import { PropsWithChildren } from 'react';

export type RightInfoRowProps = PropsWithChildren;

export const RightInfoRow = ({ children }: PropsWithChildren) => (
  <Box direction="row-responsive" gap="large" wrap>
    {children}
  </Box>
);
